export const LOCAL_STORAGE_KEY = 'finesio-inpost-basket-binding-api-key';

export function getBasketBindingApiKeyToLocalStorage(): string | null {
  return localStorage.getItem(`${LOCAL_STORAGE_KEY}`);
}

export function saveBasketBindingApiKeyToLocalStorage(
  basketBindingApiKey: string
) {
  localStorage.setItem(`${LOCAL_STORAGE_KEY}`, basketBindingApiKey);
}

export function removeBasketBindingApiKeyToLocalStorage() {
  localStorage.removeItem(`${LOCAL_STORAGE_KEY}`);
}
